
export const GET_RESET = "reset";
export const GET_EVENT = "getEvent";
export const GET_EVENT_CATEGORY = "getEventCat";
export const GET_CATALOGUE = "GET_CATALOGUE";
export const GET_All_EVENT = "getAllEvent";
export const GET_OPENING = "getOpening";
export const GET_EXHIBITION = "getExhibition";
export const GET_SOCIAL_RESPONSIBILITIES = "getSocial";
export const GET_BLOG = "getBlog";
export const GET_PROJECTS = "getProjects";
export const GET_ALL_NEWS = "getAllNews";
export const GET_ALL_PROJECTS = "getAllProjects";
export const GET_DEVELOP = "getDevelop";
export const GET_SINGLE = "getSingle";
export const GET_GAllERY = "getGallery";
export const GET_IMAGES = "getImages";
export const GET_VIDEOS = "getVideos";

